import styled from 'styled-components';

export const SkeletonItemWrapper = styled.div`
  width: 100%;
  height: 246px;
  padding: 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  margin-bottom: 10px;
  position: relative;
`;

export const SkeletonItemFeatureWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const SkeletonItemHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SkeletonItemPromotions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SkeletonItemMain = styled.div`
  margin-left: 8px;
  width: 551px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

export const SkeletonItemDivider = styled.div`
  width: 1px;
  height: 90%;
  background-image: linear-gradient(140deg, #ebebeb 1%, #ededed 52%, #ebebeb);
  position: absolute;
  right: 200px;
  top: 50%;
  transform: translateY(-50%);
`;

export const MobileSkeletonItemWrapper = styled.div`
  width: 359px;
  background-color: ${({ theme }) => theme.palette.white};
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 8px;
`;

export const MobileSkeletonItemContent = styled.div`
  margin-top: 8px;
`;

export const MobileSkeletonItemPrice = styled.div`
  width: 100%;
  height: 92px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
`;
